import { FunctionComponent } from 'react';
import { PaymentMethod } from '@shared/types';
import styles from './styles.module.scss';
import Card from '../../../../../../Card';
import { AccessCourseButton } from '../AccessCourseButton';
import { PayInvoiceButton } from '../PayInvoiceButton';
import { DownloadInvoiceButton } from '../DownloadInvoiceButton';

type ConfirmationDetailsCardProps = {
    orderId?: string;
    orderPaymentMethod?: PaymentMethod;
};

export const ConfirmationDetailsCard: FunctionComponent<ConfirmationDetailsCardProps> = ({
    orderId,
    orderPaymentMethod,
}) => {
    if (!orderId) {
        return null;
    }

    return (
        <Card>
            <h3 className={styles.heading}>Check your inbox for a confirmation email</h3>
            <span className={styles.reference}>Order reference: {orderId}</span>
            <div className={styles.buttons}>
                <AccessCourseButton orderId={orderId} />
                <PayInvoiceButton orderId={orderId} orderPaymentMethod={orderPaymentMethod} />
                <DownloadInvoiceButton />
            </div>
        </Card>
    );
};
